export default {
    data () {
        return {
            cursorAxis: {
                x: undefined,
                y: undefined,
            },
        }
    },
    mounted () {
        document.addEventListener('mousemove', this.storeCursorPosition, true)
    },
    beforeDestroy () {
        document.removeEventListener('mousemove', this.storeCursorPosition, true)
    },
    methods: {
        storeCursorPosition (e) {
            this.cursorAxis.x = e.pageX
            this.cursorAxis.y = e.pageY
        },
    },
}
